import { request } from "../httpClient";

function getUrl(prefixKey) {
  const prefix = (window.appConfig && window.appConfig[prefixKey]);
  return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchEntsoePrices({ queryKey }) {
  const [,start_date, end_date, country_code, timeout] = queryKey;
  const url = `${getUrl("getEntsoePricesUrl")}` +
    `?start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}&country_code=${encodeURIComponent(country_code)}`;
  return request(url, {}, timeout);
}